import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CreateTicket from './CreateTicket';

const Icon = ({ d, size = 16, strokeWidth = 1.75 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24"
        fill="none" stroke="currentColor"
        strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
        {Array.isArray(d) ? d.map((p, i) => <path key={i} d={p} />) : <path d={d} />}
    </svg>
);

const icons = {
    plus: ['M12 5v14', 'M5 12h14'],
    message: ['M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z'],
    close: ['M18 6L6 18', 'M6 6l12 12'],
    send: ['M22 2L11 13', 'M22 2l-7 20-4-9-9-4 20-7z'],
    back: ['M19 12H5', 'M12 19l-7-7 7-7']
};



const ticketStyles = `
.support-container {
    font-family: 'Inter', sans-serif;
    display: flex;
    flex-direction: column;
    height: 100%;
    box-sizing: border-box;
    background: #f8fafc;
}
.support-header-light {
    background: #ffffff;
    color: #0f172a;
    padding: 30px 40px;
    border-radius: 12px;
    margin: 24px 24px 0 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 6px -1px rgba(0,0,0,0.02);
}
.support-header-light h1 { margin: 0 0 8px; font-size: 24px; font-weight: 700; }
.support-header-light p { margin: 0; color: #64748b; font-size: 14px; }
.header-actions {
    display: flex;
    gap: 12px;
    margin-top: 16px;
}
.header-btn {
    background: #f1f5f9;
    color: #0f172a;
    border: 1px solid #e2e8f0;
    padding: 10px 20px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: 0.2s;
}
.header-btn:hover {
    background: #e2e8f0;
}
.header-btn.primary {
    background: #0f172a;
    color: white;
    border: none;
}
.header-btn.primary:hover {
    background: #1e293b;
}
.stats-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;
    padding: 0 24px;
    margin-top: 24px;
}
.stat-card {
    background: white;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 6px -1px rgba(0,0,0,0.02);
    border: 1px solid #e2e8f0;
}
.stat-card h3 { margin: 0 0 8px; font-size: 11px; text-transform: uppercase; color: #64748b; letter-spacing: 0.05em; }
.stat-card .value { font-size: 28px; font-weight: 700; color: #0f172a; margin-bottom: 4px; }
.stat-card p { margin: 0; font-size: 12px; color: #94a3b8; }
.main-content {
    background: white;
    margin: 24px;
    border-radius: 12px;
    box-shadow: 0 4px 6px -1px rgba(0,0,0,0.02);
    border: 1px solid #e2e8f0;
    flex: 1;
    display: flex;
    flex-direction: column;
}
.tabs-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    border-bottom: 1px solid #e2e8f0;
}
.tabs-left {
    display: flex;
    gap: 8px;
}
.tab-btn {
    padding: 8px 16px;
    border: none;
    background: transparent;
    font-weight: 600;
    color: #64748b;
    border-radius: 20px;
    cursor: pointer;
    transition: 0.2s;
}
.tab-btn:hover {
    background: #f1f5f9;
    color: #0f172a !important;
}
.tab-btn.active {
    background: #f1f5f9;
    color: #0f172a;
    box-shadow: inset 0 0 0 1px #cbd5e1;
}
.search-box {
    padding: 8px 16px;
    border: 1px solid #e2e8f0;
    border-radius: 20px;
    outline: none;
    width: 250px;
}
.modern-table {
    width: 100%;
    border-collapse: collapse;
}
.modern-table th {
    text-align: left;
    padding: 16px 24px;
    font-size: 11px;
    text-transform: uppercase;
    color: #64748b;
    border-bottom: 1px solid #e2e8f0;
    font-weight: 700;
    letter-spacing: 0.05em;
}
.modern-table td {
    padding: 16px 24px;
    font-size: 13px;
    color: #1e293b;
    border-bottom: 1px solid #f1f5f9;
}
.modal-overlay {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(15, 23, 42, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}
.modal-content {
    background: white;
    width: 900px;
    border-radius: 12px;
    box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1);
    max-height: 90vh;
    overflow-y: auto;
}
.modal-header {
    padding: 24px;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.modal-header h2 { margin: 0; font-size: 20px; color: #0f172a; }
.close-btn { background: none; border: none; font-size: 24px; cursor: pointer; color: #64748b; }
.modal-body {
    padding: 24px;
}
.form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 20px;
}
.form-group label {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: #475569;
    margin-bottom: 8px;
}
.form-group input, .form-group select, .form-group textarea {
    width: 100%;
    padding: 10px 14px;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    font-size: 14px;
    outline: none;
    box-sizing: border-box;
}
.form-group input:focus, .form-group select:focus, .form-group textarea:focus {
    border-color: #0f172a;
}
.modal-footer {
    padding: 20px 24px;
    border-top: 1px solid #e2e8f0;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
}
.btn-primary { background: #0f172a; color: white; border: none; padding: 10px 24px; border-radius: 8px; font-weight: 600; cursor: pointer; }
.btn-default { background: #f1f5f9; color: #475569; border: none; padding: 10px 24px; border-radius: 8px; font-weight: 600; cursor: pointer; }

/* Ticket View Styles */
.support-panel {
    background: #ffffff;
    margin: 24px;
    border-radius: 16px;
    box-shadow: 0 10px 30px -10px rgba(0,0,0,0.05);
    border: 1px solid #e2e8f0;
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
}
.panel-header {
    background: linear-gradient(to right, #f8fafc, #ffffff);
    padding: 24px 32px;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    align-items: center;
    gap: 24px;
}
.back-btn {
    background: white;
    border: 1px solid #e2e8f0;
    padding: 10px 16px;
    border-radius: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    color: #475569;
    box-shadow: 0 2px 4px rgba(0,0,0,0.02);
    transition: all 0.2s ease;
}
.back-btn:hover { background: #f1f5f9; transform: translateY(-1px); box-shadow: 0 4px 6px rgba(0,0,0,0.04); }
.ticket-title-wrap {
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1;
}
.ticket-title-wrap h2 { margin: 0; font-size: 22px; color: #0f172a; font-weight: 700; letter-spacing: -0.02em; }
.ticket-title-wrap .status-badge {
    border-radius: 20px !important;
    font-weight: 600 !important;
    letter-spacing: 0.02em;
}
.panel-body.flex-layout {
    display: flex;
    flex: 1;
    height: 600px;
}
.ticket-chat {
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #f8fafc;
}
.messages-container {
    flex: 1;
    padding: 32px 40px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 24px;
}
.message {
    background: white;
    padding: 24px;
    border-radius: 16px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 12px -4px rgba(0,0,0,0.03);
    max-width: 85%;
}
.message.original-message {
    align-self: flex-start;
    border-top-left-radius: 4px;
}
.message.reply-message {
    align-self: flex-start;
    border-top-left-radius: 4px;
    background: #ffffff;
}
.msg-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f1f5f9;
}
.msg-header strong {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #0f172a;
    font-size: 15px;
}
.msg-header span { color: #94a3b8; font-size: 12px; font-weight: 500; }
.msg-body {
    color: #334155;
    font-size: 15px;
    line-height: 1.6;
    white-space: pre-wrap;
}
.reply-box {
    padding: 24px 40px;
    background: white;
    border-top: 1px solid #e2e8f0;
}
.reply-box textarea {
    width: 100%;
    padding: 16px 20px;
    border: 2px solid #e2e8f0;
    border-radius: 12px;
    outline: none;
    resize: none;
    font-family: inherit;
    font-size: 15px;
    box-sizing: border-box;
    margin-bottom: 16px;
    transition: border-color 0.2s;
    background: #f8fafc;
}
.reply-box textarea:focus {
    border-color: #3b82f6;
    background: white;
}
.reply-actions {
    display: flex;
    justify-content: flex-end;
}
.reply-actions button {
    background: #0f172a;
    color: white;
    border: none;
    padding: 12px 28px;
    border-radius: 10px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    box-shadow: 0 4px 6px -1px rgba(15, 23, 42, 0.2);
    transition: all 0.2s;
}
.reply-actions button:hover:not(:disabled) {
    background: #1e293b;
    transform: translateY(-2px);
    box-shadow: 0 6px 12px -2px rgba(15, 23, 42, 0.25);
}
.reply-actions button:disabled {
    background: #94a3b8;
    cursor: not-allowed;
    box-shadow: none;
}
.ticket-sidebar {
    width: 320px;
    padding: 32px;
    background: #ffffff;
    border-left: 1px solid #e2e8f0;
    box-sizing: border-box;
    overflow-y: auto;
}
.ticket-sidebar h3 {
    margin: 0 0 24px 0;
    font-size: 13px;
    text-transform: uppercase;
    color: #64748b;
    letter-spacing: 0.1em;
    font-weight: 700;
}
.info-row {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.info-row span {
    font-size: 13px;
    color: #64748b;
    font-weight: 500;
}
.info-row strong {
    font-size: 14px;
    color: #0f172a;
}
.info-row select {
    padding: 10px 12px !important;
    border-radius: 8px !important;
    border: 1px solid #cbd5e1 !important;
    font-size: 14px !important;
    outline: none !important;
    background: #f8fafc !important;
    color: #0f172a !important;
    font-family: inherit !important;
    transition: border-color 0.2s !important;
}
.info-row select:focus {
    border-color: #3b82f6 !important;
    background: white !important;
}
`

export default function SupportTickets({ context, userDetails, trips = [] }) {
    const [tickets, setTickets] = useState([]);
    const [activeTab, setActiveTab] = useState('internal');
    const [loading, setLoading] = useState(true);
    const [view, setView] = useState('list');
    const [selectedTicket, setSelectedTicket] = useState(null);
    const [formData, setFormData] = useState({ subject: '', description: '', department: '', service: '', priority: '', assignee: '', tripId: '', issueType: '', attachment: null, clientId: '', vehicleId: '', driverId: '', contactEmail: '' });
    const [replyContent, setReplyContent] = useState('');
    const [showNotification, setShowNotification] = useState(false);
    const [departments, setDepartments] = useState([]);
    const [services, setServices] = useState([]);
    const [priorities, setPriorities] = useState([]);
    const [statuses, setStatuses] = useState([]);
    const [users, setUsers] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [clients, setClients] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [drivers, setDrivers] = useState([]);
    const [dispatchVendorId, setDispatchVendorId] = useState('');
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        fetchTickets();
        fetchMasterData();
    }, [context, userDetails]);

    const updateTicketField = async (field, value) => {
        if (!selectedTicket) return;
        try {
            await axios.put(`/api/tickets/${selectedTicket._id}`, { [field]: value });
            const res = await axios.get(`/api/tickets/${selectedTicket._id}`);
            setSelectedTicket(res.data);
            fetchTickets();
        } catch (err) {
            console.error('Failed to update ticket:', err);
            alert("Failed to update ticket.");
        }
    };

    const fetchMasterData = async () => {
        try {
            const promises = [
                axios.get('/api/departments/all'),
                axios.get('/api/services'),
                axios.get('/api/master-data')
            ];

            if (context === 'operator' || context === 'admin') {
                const opId = userDetails.operatorId || userDetails._id;
                if (opId) {
                    promises.push(axios.get(`/api/users/${opId}`));
                    promises.push(axios.get(`/api/vendors/${opId}`));
                    promises.push(axios.get(`/api/clients/${opId}`));
                    promises.push(axios.get(`/api/vehicles/${opId}`));
                    promises.push(axios.get(`/api/drivers/${opId}`));
                }
            }

            const results = await Promise.all(promises);
            setDepartments(results[0].data);
            setServices(results[1].data);
            setPriorities(results[2].data.filter(i => i.category === 'ticket-priority' && i.active !== false));
            setStatuses(results[2].data.filter(i => i.category === 'ticket-status' && i.active !== false));
            
            if (results[3]) {
                setUsers(results[3].data);
            }
            if (results[4]) {
                setVendors(results[4].data);
            }
            if (results[5]) {
                setClients(results[5].data);
            }
            if (results[6]) {
                setVehicles(results[6].data);
            }
            if (results[7]) {
                setDrivers(results[7].data);
            }
        } catch (err) {
            console.error('Error fetching master data:', err);
        }
    };

    const fetchTickets = async () => {
        setLoading(true);
        try {
            let url = '/api/tickets';
            if (context === 'client') {
                url += `?clientId=${userDetails._id}`;
            } else if (context === 'vendor') {
                url += `?vendorId=${userDetails._id}`;
            } else if (context === 'operator') {
                url += `?operatorId=${userDetails.operatorId || userDetails._id}`;
            }
            const res = await axios.get(url);
            setTickets(res.data);
            
            // Auto-switch to assigned tab if there are tickets assigned to this user (only if it's the first load or still internal)
            const myAssigned = res.data.filter(t => t.assignee === userDetails._id || (t.assignee && t.assignee._id === userDetails._id));
            if (myAssigned.length > 0 && activeTab === 'internal') {
                setActiveTab('assigned');
            }
        } catch (err) {
            console.error('Error fetching tickets:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleCreateTicket = async (e) => {
        e.preventDefault();
        if (!formData.subject || !formData.description) return alert("Subject and Description are required");

        const newTicket = {
            subject: formData.subject,
            description: formData.description,
            department: formData.department || undefined,
            service: formData.service || undefined,
            priority: formData.priority || undefined,
            assignee: formData.assignee || undefined,
            tripId: formData.tripId || undefined,
            clientId: formData.clientId || undefined,
            vehicleId: formData.vehicleId || undefined,
            driverId: formData.driverId || undefined,
            issueType: formData.issueType || 'Support Ticket',
            contactName: userDetails.firstName ? `${userDetails.firstName} ${userDetails.lastName || ''}` : userDetails.companyName,
            contactEmail: formData.contactEmail || userDetails.email,
            createdByRole: context.charAt(0).toUpperCase() + context.slice(1),
        };

        if (context === 'client') {
            newTicket.clientId = userDetails._id;
            newTicket.operatorId = userDetails.operatorId;
        } else if (context === 'vendor') {
            newTicket.vendorId = userDetails._id;
            newTicket.operatorId = userDetails.operatorId;
        } else if (context === 'operator') {
            newTicket.operatorId = userDetails.operatorId || userDetails._id;
        }

        try {
            await axios.post('/api/tickets', newTicket);
            setShowNotification(true);
            setTimeout(() => setShowNotification(false), 3000);
            setView('list');
            setFormData({ subject: '', description: '', department: '', service: '', priority: '', assignee: '', tripId: '', issueType: '', attachment: null, clientId: '', vehicleId: '', driverId: '', contactEmail: '' });
            fetchTickets();
        } catch (err) {
            console.error('Error creating ticket:', err);
            alert("Failed to create ticket.");
        }
    };

    const handleCreateSuperadminTicket = async (e) => {
        e.preventDefault();
        if (!formData.subject || !formData.description) return alert("Subject and Description are required");

        const newTicket = {
            subject: formData.subject,
            description: formData.description,
            priority: formData.priority || undefined,
            department: formData.department || undefined,
            service: formData.service || undefined,
            issueType: formData.issueType || undefined,
            contact: formData.contact || undefined,
            contactName: formData.contactName || (userDetails.firstName ? `${userDetails.firstName} ${userDetails.lastName || ''}` : userDetails.companyName),
            contactEmail: formData.contactEmail || userDetails.email,
            createdByRole: 'Operator',
            operatorId: userDetails.operatorId || userDetails._id,
            tags: formData.tags ? formData.tags.split(',').map(t => t.trim()) : ['To Superadmin']
        };

        try {
            if (formData.attachment) {
                const uploadData = new FormData();
                uploadData.append('document', formData.attachment);
                const uploadRes = await axios.post('/upload', uploadData);
                newTicket.attachment = uploadRes.data.filename || (uploadRes.data.filenames && uploadRes.data.filenames[0]);
            }
            await axios.post('/api/tickets', newTicket);
            setShowNotification(true);
            setTimeout(() => setShowNotification(false), 3000);
            setView('list');
            setFormData({ subject: '', description: '', department: '', service: '', priority: '', assignee: '', tripId: '', issueType: '', attachment: null });
            fetchTickets();
        } catch (err) {
            console.error('Error creating superadmin ticket:', err);
            alert("Failed to create ticket.");
        }
    };

    const handleReply = async (e) => {
        e.preventDefault();
        if (!replyContent) return;
        try {
            await axios.post(`/api/tickets/${selectedTicket._id}/replies`, {
                user: userDetails.firstName ? `${userDetails.firstName} ${userDetails.lastName || ''}` : userDetails.companyName || userDetails.vendorName || 'User',
                content: replyContent,
                type: 'reply',
                senderRole: context.charAt(0).toUpperCase() + context.slice(1)
            });
            setReplyContent('');
            // Refresh ticket
            const res = await axios.get(`/api/tickets/${selectedTicket._id}`);
            setSelectedTicket(res.data);
            fetchTickets(); // update list to get latest reply date
        } catch (err) {
            console.error('Error sending reply:', err);
            alert("Failed to send reply.");
        }
    };

    if (view === 'create') {
        return (
            <div className="support-container">
                <div className="support-header-light" style={{ margin: '24px' }}>
                    <button className="header-btn" onClick={() => setView('list')}><Icon d={icons.back} /> Back to Tickets</button>
                    <h2 style={{ margin: 0, fontSize: '20px' }}>Log Support / Task Assignment</h2>
                    <div style={{ width: '120px' }}></div>
                </div>
                <div className="main-content" style={{ padding: '30px' }}>
                    <form id="ticketForm" onSubmit={handleCreateTicket}>
                                <div className="form-grid">
                                    <div className="form-group">
                                        <label>Issue / Task Title</label>
                                        <input type="text" placeholder="Select Task/Issue..." value={formData.subject} onChange={e => setFormData({...formData, subject: e.target.value})} required />
                                    </div>
                                    <div className="form-group">
                                        <label>Type</label>
                                        <select value={formData.issueType || ''} onChange={e => setFormData({...formData, issueType: e.target.value})}>
                                            <option value="">Support Ticket</option>
                                            <option value="Complaint">Complaint</option>
                                            <option value="Task">Task</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Priority</label>
                                        <select value={formData.priority || ''} onChange={e => setFormData({...formData, priority: e.target.value})}>
                                            <option value="">Medium</option>
                                            {priorities.map(p => <option key={p._id} value={p._id}>{p.name}</option>)}
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Assign To Staff</label>
                                        <select value={formData.assignee || ''} onChange={e => setFormData({...formData, assignee: e.target.value})}>
                                            <option value="">Select Staff Member</option>
                                            {users.map(u => <option key={u._id} value={u._id}>{u.firstName} {u.lastName}</option>)}
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Created Date</label>
                                        <input type="date" value={new Date().toISOString().split('T')[0]} readOnly style={{ background: '#f8fafc' }} />
                                    </div>
                                    <div className="form-group">
                                        <label>Linked Customer (Optional)</label>
                                        <select value={formData.clientId || ''} onChange={e => setFormData({...formData, clientId: e.target.value})}>
                                            <option value="">Select Corporate Customer</option>
                                            {clients.map(c => <option key={c._id} value={c._id}>{c.companyName}</option>)}
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Customer Mail</label>
                                        <input type="email" placeholder="Enter customer email to send notification" value={formData.contactEmail || ''} onChange={e => setFormData({...formData, contactEmail: e.target.value})} />
                                    </div>
                                    <div className="form-group">
                                        <label>Linked Driver (Optional)</label>
                                        <select value={formData.driverId || ''} onChange={e => setFormData({...formData, driverId: e.target.value})}>
                                            <option value="">Select Driver</option>
                                            {drivers.map(d => <option key={d._id} value={d._id}>{d.name}</option>)}
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Linked Fleet Asset (Optional)</label>
                                        <select value={formData.vehicleId || ''} onChange={e => setFormData({...formData, vehicleId: e.target.value})}>
                                            <option value="">Select Fleet Asset</option>
                                            {vehicles.map(v => <option key={v._id} value={v._id}>{v.make} {v.model}</option>)}
                                        </select>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>Description / Problem Statement</label>
                                    <textarea rows="4" placeholder="Detail description of the ticket/complaint..." value={formData.description} onChange={e => setFormData({...formData, description: e.target.value})} required></textarea>
                                </div>
                            </form>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '24px' }}>
                        <button type="button" className="header-btn" onClick={() => setView('list')}>Cancel</button>
                        <button type="submit" form="ticketForm" className="header-btn primary">Submit Ticket</button>
                    </div>
                </div>
                <style>{ticketStyles}</style>
            </div>
        );
    }
    if (view === 'create-superadmin') {
        return (
            <CreateTicket 
                user={userDetails} 
                isSuperadmin={true}
                onCancel={() => setView('list')} 
                onSaved={() => { setView('list'); fetchTickets(); }} 
            />
        );
    }

    if (view === 'view' && selectedTicket) {
        return (
            <div className="support-panel">
                <style>{ticketStyles}</style>
                <div className="panel-header">
                    <button className="back-btn" onClick={() => setView('list')}><Icon d={icons.back} /> Back</button>
                    <div className="ticket-title-wrap">
                        <h2>{selectedTicket.subject}</h2>
                        <span className="status-badge" style={{ background: '#f8fafc', border: '1px solid #e2e8f0', color: '#475569', padding: '6px 12px', fontSize: '13px' }}>{selectedTicket.status?.name || 'Open'}</span>
                    </div>
                </div>
                <div className="panel-body flex-layout">
                    <div className="ticket-chat">
                        <div className="messages-container">
                            <div className="message original-message">
                                <div className="msg-header">
                                    <strong><Icon d={icons.message} size={16}/> {selectedTicket.contactName || 'User'} <span style={{ color: '#94a3b8', fontSize: '12px', fontWeight: 'normal', marginLeft: '4px' }}>({selectedTicket.createdByRole || 'Client'})</span></strong>
                                    <span>{new Date(selectedTicket.createdAt).toLocaleString()}</span>
                                </div>
                                <div className="msg-body">{selectedTicket.description}</div>
                            </div>

                            {selectedTicket.replies?.map((reply, idx) => (
                                <div key={idx} className="message reply-message">
                                    <div className="msg-header">
                                        <strong><Icon d={icons.message} size={16}/> {reply.user}</strong>
                                        <span>{new Date(reply.createdAt).toLocaleString()}</span>
                                    </div>
                                    <div className="msg-body">{reply.content}</div>
                                </div>
                            ))}
                        </div>

                        {context === 'operator' && !selectedTicket.tags?.includes('To Superadmin') && (
                            <div style={{ padding: '16px 24px', background: '#fff', borderTop: '1px solid #e2e8f0', display: 'flex', gap: '12px', alignItems: 'center' }}>
                                <label style={{ fontSize: '13px', fontWeight: 700, color: '#475569' }}>Dispatch to Vendor:</label>
                                <select 
                                    style={{ flex: 1, padding: '10px 14px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '14px', outline: 'none' }}
                                    value={dispatchVendorId}
                                    onChange={e => setDispatchVendorId(e.target.value)}
                                >
                                    <option value="">-- Select Vendor --</option>
                                    {vendors.map(v => <option key={v._id} value={v._id}>{v.vendorName}</option>)}
                                </select>
                                <button 
                                    style={{ background: '#10b981', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', fontWeight: 600, cursor: 'pointer' }}
                                    disabled={!dispatchVendorId}
                                    onClick={async () => {
                                        if(!dispatchVendorId) return;
                                        try {
                                            await axios.put(`/api/tickets/${selectedTicket._id}`, { vendorId: dispatchVendorId });
                                            alert("Ticket dispatched to vendor successfully.");
                                            fetchTickets();
                                            const res = await axios.get(`/api/tickets/${selectedTicket._id}`);
                                            setSelectedTicket(res.data);
                                            setDispatchVendorId('');
                                        } catch (e) {
                                            console.error(e);
                                            alert("Failed to dispatch ticket.");
                                        }
                                    }}
                                >
                                    Dispatch
                                </button>
                            </div>
                        )}

                        <div className="reply-box">
                            <form onSubmit={handleReply}>
                                <textarea 
                                    placeholder="Type your reply here..." 
                                    rows="3"
                                    value={replyContent}
                                    onChange={e => setReplyContent(e.target.value)}
                                ></textarea>
                                <div className="reply-actions">
                                    <button type="submit" disabled={!replyContent.trim()}><Icon d={icons.send} /> Send Reply</button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="ticket-sidebar">
                        <h3>Ticket Info</h3>
                        <div className="info-row">
                            <span>Status:</span>
                            {context === 'operator' || context === 'admin' ? (
                                <select 
                                    style={{ padding: '6px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '13px', outline: 'none', background: '#fff' }}
                                    value={selectedTicket.status?._id || ''} 
                                    onChange={e => updateTicketField('status', e.target.value)}
                                >
                                    {!selectedTicket.status && <option value="">Open</option>}
                                    {statuses.map(s => <option key={s._id} value={s._id}>{s.name}</option>)}
                                </select>
                            ) : (
                                <strong>{selectedTicket.status?.name || 'Open'}</strong>
                            )}
                        </div>
                        <div className="info-row">
                            <span>Priority:</span>
                            {context === 'operator' || context === 'admin' ? (
                                <select 
                                    style={{ padding: '6px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '13px', outline: 'none', background: '#fff' }}
                                    value={selectedTicket.priority?._id || ''} 
                                    onChange={e => updateTicketField('priority', e.target.value)}
                                >
                                    {!selectedTicket.priority && <option value="">Normal</option>}
                                    {priorities.map(p => <option key={p._id} value={p._id}>{p.name}</option>)}
                                </select>
                            ) : (
                                <strong>{selectedTicket.priority?.name || 'Normal'}</strong>
                            )}
                        </div>
                        <div className="info-row">
                            <span>Department:</span>
                            <strong>{selectedTicket.department?.name || 'General'}</strong>
                        </div>
                        <div className="info-row">
                            <span>Created:</span>
                            <strong>{new Date(selectedTicket.createdAt).toLocaleDateString()}</strong>
                        </div>
                        <div className="info-row">
                            <span>From:</span>
                            <strong>{selectedTicket.createdByRole || 'User'}</strong>
                        </div>
                        {selectedTicket.createdByRole === 'Passenger' && selectedTicket.clientId && (
                            <div className="info-row">
                                <span>Client:</span>
                                <strong>{selectedTicket.clientId.companyName}</strong>
                            </div>
                        )}
                        {selectedTicket.issueType && (
                            <div className="info-row">
                                <span>Related To:</span>
                                <strong>{selectedTicket.issueType}</strong>
                            </div>
                        )}
                        <div className="info-row">
                            <span>Attachment:</span>
                            {selectedTicket.attachment ? (
                                <a href={`/uploads/${selectedTicket.attachment}`} target="_blank" rel="noreferrer" style={{ color: '#2563eb', fontWeight: 600, textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <Icon d={icons.download} size={14} /> View File
                                </a>
                            ) : <strong>None</strong>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const openCount = tickets.filter(t => t.status?.name === 'Open').length;
    const inProgressCount = tickets.filter(t => t.status?.name === 'In Progress').length;
    const unassignedCount = tickets.filter(t => !t.assignee).length;
    const solvedCount = tickets.filter(t => t.status?.name === 'Resolved' || t.status?.name === 'Closed').length;

    const filteredTickets = tickets.filter(t => {
        if (context !== 'operator') return true;
        if (activeTab === 'assigned') return t.assignee === userDetails._id || (t.assignee && t.assignee._id === userDetails._id);
        
        const isAssignedToMe = t.assignee === userDetails._id || (t.assignee && t.assignee._id === userDetails._id);
        if (activeTab === 'superadmin') return t.tags?.includes('To Superadmin') && !isAssignedToMe;
        if (activeTab === 'passenger') return t.createdByRole === 'Passenger' && !isAssignedToMe;
        if (activeTab === 'driver') return t.createdByRole === 'Driver' && !isAssignedToMe;
        
        return !t.tags?.includes('To Superadmin') && t.createdByRole !== 'Passenger' && t.createdByRole !== 'Driver' && !isAssignedToMe;
    });

    return (
        <div className="support-container">
            {showNotification && (
                <div className="notification-toast">
                    <Icon d={icons.message} /> Ticket Created Successfully!
                </div>
            )}
            
            <div className="support-header-light">
                <div>
                    <h1>Support Tickets</h1>
                    <p>Manage and track your support requests</p>
                </div>
                <div style={{ display: 'flex', gap: '16px' }}>
                    <button className="header-btn primary" onClick={() => setView('create')}>
                        <Icon d={icons.plus} /> Create Ticket
                    </button>
                    <button className="header-btn">Export</button>
                </div>
            </div>

            <div className="stats-grid">
                <div className="stat-card">
                    <h3>Open Tickets</h3>
                    <div className="value">{openCount}</div>
                    <p>Awaiting initial response</p>
                </div>
                <div className="stat-card">
                    <h3>In Progress</h3>
                    <div className="value">{inProgressCount}</div>
                    <p>Currently being handled</p>
                </div>
                <div className="stat-card">
                    <h3>Unassigned</h3>
                    <div className="value">{unassignedCount}</div>
                    <p>Awaiting staff assignment</p>
                </div>
                <div className="stat-card">
                    <h3>Solved</h3>
                    <div className="value">{solvedCount}</div>
                    <p>Resolved and finalized</p>
                </div>
                <div className="stat-card">
                    <h3>Total Registered</h3>
                    <div className="value">{tickets.length}</div>
                    <p>Total logged tickets</p>
                </div>
            </div>

            <div className="main-content">
                <div className="tabs-bar">
                    {context === 'operator' && (
                        <div className="tabs-left">
                            <button className={`tab-btn ${activeTab === 'assigned' ? 'active' : ''}`} onClick={() => setActiveTab('assigned')}>Assigned to You</button>
                            <button className={`tab-btn ${activeTab === 'internal' ? 'active' : ''}`} onClick={() => setActiveTab('internal')}>Client & Vendor</button>
                            <button className={`tab-btn ${activeTab === 'passenger' ? 'active' : ''}`} onClick={() => setActiveTab('passenger')}>Passenger</button>
                            <button className={`tab-btn ${activeTab === 'driver' ? 'active' : ''}`} onClick={() => setActiveTab('driver')}>Driver</button>
                            <button className={`tab-btn ${activeTab === 'superadmin' ? 'active' : ''}`} onClick={() => setActiveTab('superadmin')}>To Superadmin</button>
                        </div>
                    )}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginLeft: 'auto' }}>
                        <input type="text" className="search-box" placeholder="Search tickets..." />
                    </div>
                </div>

                <div style={{ overflowX: 'auto' }}>
                    <table className="modern-table">
                        <thead>
                            <tr>
                                <th>Ticket No</th>
                                <th>Title</th>
                                <th>Type</th>
                                <th>Priority</th>
                                <th>Status</th>
                                <th>Customer</th>
                                <th>Fleet Asset</th>
                                <th>Driver ID</th>
                                <th>Assigned Staff</th>
                                <th>Deadline</th>
                                <th>Created At</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="12" style={{ textAlign: 'center', padding: '40px' }}>Loading tickets...</td></tr>
                            ) : filteredTickets.length === 0 ? (
                                <tr><td colSpan="12" style={{ textAlign: 'center', padding: '40px' }}>No tickets found</td></tr>
                            ) : (
                                filteredTickets.map((t, idx) => (
                                    <tr key={t._id}>
                                        <td style={{ fontWeight: 600, color: '#0f172a' }}>TK-{(idx + 1000).toString()}</td>
                                        <td>
                                            <div style={{ fontWeight: 600, color: '#0f172a' }}>{t.subject}</div>
                                            <div style={{ fontSize: '11px', color: '#64748b', maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{t.description}</div>
                                        </td>
                                        <td><span style={{ color: '#475569', background: '#f1f5f9', padding: '4px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 600 }}>{t.issueType || 'Ticket'}</span></td>
                                        <td>
                                            <span style={{ color: '#b45309', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                <div style={{ width: '8px', height: '8px', background: '#f59e0b', borderRadius: '50%' }}></div>
                                                {t.priority?.name || 'Medium'}
                                            </span>
                                        </td>
                                        <td><span className="status-badge" style={{ background: '#f8fafc', border: '1px solid #e2e8f0', color: '#475569', padding: '4px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 600 }}>{t.status?.name || 'Open'}</span></td>
                                        <td>{t.clientId?.companyName || t.contactName || '-'}</td>
                                        <td>{t.vehicleId ? `${t.vehicleId.make} ${t.vehicleId.model} (${t.vehicleId.registrationNumber})` : '-'}</td>
                                        <td>{t.driverId?.name || '-'}</td>
                                        <td>{t.assignee ? `${t.assignee.firstName} ${t.assignee.lastName}` : '-'}</td>
                                        <td>{t.deadline ? new Date(t.deadline).toLocaleDateString() : '-'}</td>
                                        <td>{new Date(t.createdAt).toLocaleString()}</td>
                                        <td>
                                            <button style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#3b82f6', marginRight: '16px' }} onClick={() => { setSelectedTicket(t); setView('view'); }} title="View / Reply"><Icon d={icons.message} size={16} /></button>
                                            <button style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444' }} title="Close Ticket"><Icon d={icons.close} size={14} /></button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            
            <style>{ticketStyles}</style>
        </div>
    );
}